import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { UtilsService } from 'src/app/core/utils.service';
import { DetailVopRequest, VopCall, VopRequest } from 'src/app/core/vop-request.service';
import { VOP_REQUEST_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';
import { VopRequestDetailDialogComponent } from '../vop-request-detail-dialog/vop-request-detail-dialog.component';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-vop-request-data-table',
  templateUrl: './vop-request-data-table.component.html',
  styleUrls: ['./vop-request-data-table.component.scss'],
})
export class VopRequestDataTableComponent {
  @Input() vop_requests: VopRequest[] = [];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();
  displayed_columns: string[] = VOP_REQUEST_TABLE_COLUMNS;

  constructor(
    private utils_service: UtilsService,
    private dialog_service: DialogService,
    private decimal_pipe: DecimalPipe,
  ) {}

  onDetailsClick(vop_request: VopRequest): void {
    const vop_calls: DetailVopRequest[] = [];
    const call_types: ('fl_call' | 'lf_call' | 'tax_code_call')[] = ['fl_call', 'lf_call', 'tax_code_call'];

    for (const call_type of call_types) {
      if (vop_request[call_type]) {
        vop_calls.push({
          type: call_type,
          vop_call: vop_request[call_type] as VopCall,
          created_at: vop_request.created_at,
        });
      }
    }
    console.log(vop_calls);

    this.dialog_service.openDialog(VopRequestDetailDialogComponent, {
      vop_calls: vop_calls,
    });
  }

  getVopRequestStatusBackgroundClass(vop_request?: VopRequest): { [key: string]: boolean } {
    if (!vop_request) return {};
    return this.utils_service.getVopRequestStatusBackgroundClass(vop_request);
  }

  getVopRequestStatusLabel(vop_request: VopRequest): string {
    if (!vop_request?.status) return '';
    return this.utils_service.getVopRequestStatusLabel(vop_request.status);
  }

  getVopRequestMostSimilarCallLabel(vop_request: VopRequest): string {
    if (!vop_request?.most_similar_call) return '-';
    return this.utils_service.getVopRequestMostSimilarCallLabel(vop_request.most_similar_call);
  }

  getVopRequestResultLabel(vop_request: VopRequest): string {
    if (!vop_request?.result) return '-';
    return this.utils_service.getVopRequestResultLabel(vop_request.result);
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  formatNumber(digits: number): string | null {
    return this.decimal_pipe.transform(digits, '0.2-2', 'it-IT');
  }
}
